/**
 * We won't need this hack once bid-ask data is migrated to AWS.
 */
export function fillPriceDates<T>(
  priceDates: readonly string[],
  data: readonly T[],
  dataDates: readonly string[]
): [string, T][] {
  if (dataDates.length === 0) return [];
  const fixedData: [string, T][] = [];
  let nextDataIndex = 0;
  for (const priceDate of priceDates) {
    while (
      nextDataIndex < dataDates.length - 1 &&
      priceDate > dataDates[nextDataIndex]
    ) {
      nextDataIndex++;
    }
    if (priceDate === dataDates[nextDataIndex]) {
      fixedData.push([priceDate, data[nextDataIndex]]);
      nextDataIndex++;
    } else {
      // fill with empty data points
      fixedData.push([priceDate, undefined]);
    }
  }

  return fixedData;
}
